(function(){
  function init(){
  var roots = document.querySelectorAll('.gfs');
  roots.forEach(function(root){
    if(root.dataset.gfsInit) return; root.dataset.gfsInit = '1';
    var cfg, quiz;
    try{ cfg = JSON.parse(root.querySelector('.gfs-config').textContent); }catch(e){ cfg = {}; }
    try{ quiz = JSON.parse(root.querySelector('.gfs-quiz').textContent); }catch(e){ quiz = []; }
    var FR = (cfg && cfg.franchises) || [];
    var CRIT = ((cfg && cfg.criteria) || []).map(function(s){ return (s || '').trim(); });
    if(FR.length < 2 || !quiz.length){
      root.querySelector('.gfs-qc').innerHTML = '<p style="color:#77776e">Configuration incomplète : ajoutez au moins 2 franchises et un quiz.</p>';
      return;
    }
    var handles = FR.map(function(f){ return f.handle; });
    var byHandle = {}; FR.forEach(function(f){ byHandle[f.handle] = f; });
    var MAX = {}; handles.forEach(function(h){ MAX[h] = 0; });
    quiz.forEach(function(q){
      handles.forEach(function(h){
        var m = 0; (q.opts || []).forEach(function(o){ var v = (o.s && o.s[h]) || 0; if(v > m) m = v; });
        MAX[h] += m;
      });
    });

    var $ = function(sel){ return root.querySelector(sel); };
    var pb = $('.gfs-pb'), sn = $('.gfs-sn'), st = $('.gfs-st'), qc = $('.gfs-qc'),
        qb = $('.gfs-qb'), result = $('.gfs-result'), quizband = $('.gfs-quizband');

    // luminance -> texte lisible sur l'accent
    function isBright(hex){
      var c = (hex || '').replace('#',''); if(c.length === 3) c = c.replace(/(.)/g,'$1$1');
      var r = parseInt(c.substr(0,2),16), g = parseInt(c.substr(2,2),16), b = parseInt(c.substr(4,2),16);
      if(isNaN(r)) return false;
      return (0.299*r + 0.587*g + 0.114*b) > 150;
    }
    function esc(s){ return (s == null ? '' : String(s)).replace(/[&<>"]/g, function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }
    function RK(c){ return '<svg viewBox="0 0 24 40" fill="none" stroke="'+c+'" stroke-width="1.1"><ellipse cx="12" cy="11" rx="9" ry="10.5"/><path d="M12 21.5V38M8.6 38h6.8" stroke-width="1.8"/><path d="M5 7l14 8M5 15l14-8M12 .8v20.5M2.5 11h19" stroke-width="0.5" opacity=".45"/></svg>'; }

    // total & compteur
    if(st) st.textContent = quiz.length;
    var qcountEl = root.querySelector('.gfs-qcount'); if(qcountEl) qcountEl.textContent = quiz.length;

    // pills rapides (hero) -> comparateur direct
    var rk3 = root.querySelector('.gfs-rk3');
    if(rk3){
      rk3.innerHTML = FR.map(function(f){
        return '<button type="button" style="--pc:'+esc(f.accent)+'"><span class="d"></span>'+esc(f.short || f.name)+'</button>';
      }).join('');
      rk3.querySelectorAll('button').forEach(function(b){ b.addEventListener('click', function(){ finish(true); }); });
    }

    var step = 0, answers = [];
    function renderQ(){
      var q = quiz[step];
      if(sn) sn.textContent = step + 1;
      if(pb) pb.style.width = (step / quiz.length * 100) + '%';
      if(qb) qb.style.visibility = step === 0 ? 'hidden' : 'visible';
      result.innerHTML = '';
      var h = '<div class="gfs-qnum">'+esc(q.n)+'</div><div class="gfs-qtitle">'+esc(q.q)+'</div><div class="gfs-opts">';
      (q.opts || []).forEach(function(o,i){
        h += '<button type="button" class="gfs-opt" data-i="'+i+'" aria-pressed="false"><span class="ic">'+esc(o.ic)+'</span><span class="oh">'+esc(o.h)+'</span><span class="od">'+esc(o.d)+'</span></button>';
      });
      qc.innerHTML = h + '</div>';
      qc.querySelectorAll('.gfs-opt').forEach(function(btn){ btn.addEventListener('click', function(){ pick(+btn.dataset.i); }); });
    }
    function pick(i){ answers[step] = i; step++; if(step >= quiz.length){ finish(false); } else { renderQ(); } }
    function prevQ(){ if(step > 0){ step--; renderQ(); } }
    if(qb) qb.addEventListener('click', prevQ);

    function finish(direct){
      var ranked;
      if(direct){
        ranked = FR.map(function(f,i){ return { h:f.handle, pct:null, i:i }; });
        qc.innerHTML = ''; if(pb) pb.style.width = '0%'; if(sn) sn.textContent = '1';
      } else {
        var sc = {}; handles.forEach(function(h){ sc[h] = 0; });
        answers.forEach(function(ai, qi){
          var o = quiz[qi].opts[ai]; if(!o || !o.s) return;
          handles.forEach(function(h){ sc[h] += (o.s[h] || 0); });
        });
        ranked = FR.map(function(f,i){
          var pct = MAX[f.handle] > 0 ? Math.round(sc[f.handle] / MAX[f.handle] * 100) : 0;
          return { h:f.handle, pct:pct, i:i };
        }).sort(function(a,b){ return b.pct - a.pct || a.i - b.i; });
        if(pb) pb.style.width = '100%'; qc.innerHTML = '';
      }
      if(qb) qb.style.visibility = 'hidden';

      var win = direct ? null : byHandle[ranked[0].h];
      var wac = win ? win.accent : '#C8E81C';
      var h = '';
      if(win){
        var ink = isBright(wac);
        h += '<div class="gfs-rhero" style="--wac:'+esc(wac)+'"><div class="gfs-lay">'
          + '<div class="gfs-rracket" style="--wac:'+esc(wac)+'">'+RK(wac)+'</div>'
          + '<div class="gfs-rinfo"><span class="gfs-matchpill'+(ink?' ink':'')+'">★ '+ranked[0].pct+'% DE COMPATIBILITÉ</span>'
          + '<div class="gfs-rname">'+esc(win.name)+'</div><div class="gfs-rsig">'+esc(win.sig)+'</div>'
          + '<p class="gfs-rwhy">'+esc(win.why)+'</p>'
          + '<div class="gfs-champs">'+((win.champs||[]).map(function(c){ return '<span class="gfs-chip">'+esc(c)+'</span>'; }).join(''))+'</div>'
          + '<div class="gfs-rcta"><a class="gfs-btn" style="background:'+esc(wac)+';color:'+(ink?'#18180F':'#fff')+'" href="/collections/'+esc(win.handle)+'">Découvrir la '+esc(win.name)+' →</a></div>'
          + '</div></div></div>';
      }
      h += '<div class="gfs-sect">'+(win?'Ton classement':'Les franchises')+'</div><div class="gfs-rank">';
      ranked.forEach(function(r, i){
        var f = byHandle[r.h];
        h += '<div class="gfs-rrow" style="--rac:'+esc(f.accent)+'">'
          + '<div class="pos">'+(i+1)+'</div><div class="nm">'+esc(f.short || f.name)+'<small>'+esc(f.sig)+'</small></div>'
          + '<div class="bar"><i data-w="'+(r.pct == null ? 70 : r.pct)+'" style="background:'+esc(f.accent)+'"></i></div>'
          + '<div class="pct" style="color:'+esc(f.accent)+';filter:brightness(.85)">'+(r.pct != null ? r.pct + '%' : '')+'</div>'
          + '<a href="/collections/'+esc(f.handle)+'">Voir →</a></div>';
      });
      h += '</div>';
      h += '<div class="gfs-sect">Comparateur</div><div class="gfs-cmp"><div class="gfs-cmp-leg">'
        + FR.map(function(f){ return '<span><i style="background:'+esc(f.accent)+'"></i>'+esc(f.short || f.name)+'</span>'; }).join('')
        + '</div>';
      CRIT.forEach(function(cr, ci){
        h += '<div class="gfs-crit"><div class="cl">'+esc(cr)+'</div>';
        FR.forEach(function(f){
          var v = (f.profile && f.profile[ci] != null) ? f.profile[ci] : 0;
          h += '<div class="gfs-tb"><span class="tn">'+esc(f.short || f.name)+'</span><span class="track"><i data-w="'+v+'" style="background:'+esc(f.accent)+'"></i></span><span class="tv" style="color:'+esc(f.accent)+';filter:brightness(.85)">'+v+'</span></div>';
        });
        h += '</div>';
      });
      h += '</div><div class="gfs-restart"><button type="button" class="gfs-btn gfs-out" style="color:#18180F">↺ Refaire le test</button></div>';
      result.innerHTML = h;
      result.querySelector('.gfs-restart button').addEventListener('click', restart);
      setTimeout(function(){ result.querySelectorAll('[data-w]').forEach(function(el){ el.style.width = el.getAttribute('data-w') + '%'; }); }, 100);
      if(direct && result.scrollIntoView){ result.scrollIntoView({ behavior:'smooth' }); }
    }
    function restart(){ step = 0; answers = []; renderQ(); if(quizband && quizband.scrollIntoView) quizband.scrollIntoView({ behavior:'smooth' }); }

    var cta = root.querySelector('.gfs-cta');
    if(cta) cta.addEventListener('click', function(){ if(quizband && quizband.scrollIntoView) quizband.scrollIntoView({ behavior:'smooth' }); });
    var cmpBtn = root.querySelector('.gfs-compare');
    if(cmpBtn) cmpBtn.addEventListener('click', function(){ finish(true); });

    renderQ();
  });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
